// extracted by mini-css-extract-plugin
module.exports = {"editableButton":"Title_editableButton__sbEs_"};